import {AxiosPromise} from 'axios';

import {ActionType, EmptyActionType} from '@typescript/common/actionTypes';
import {ProductReviewFormType} from '@typescript/productTypes';
import {PRODUCT} from 'constants/actions';
import {ENDPOINTS} from 'constants/endpoints';
import {instanceGusaBackend} from 'libs/api';
import {API_URL} from '../../../constants/api';

/**
 * Clears the list of reviews.
 *
 * @return {EmptyActionType} an action
 */
export const clearReviews = (): EmptyActionType => ({type: PRODUCT.CLEAR_REVIEWS});

/**
 * Clears sending review status.
 *
 * @return {EmptyActionType} an action
 */
export const clearSendingReviewStatus = (): EmptyActionType => ({
    type: PRODUCT.CLEAR_SENDING_STATUS_REVIEW,
});

/**
 * Fetch reviews list
 * @param {number} productId Product id
 * @param {number} limit Reviews limit
 * @param {number} offset Reviews offset
 * @returns {ActionType<AxiosPromise>} Action
 */
export function fetchReviews(
    productId: number,
    limit: number,
    offset: number,
): ActionType<AxiosPromise> {
    return {
        type: PRODUCT.FETCH_REVIEWS,
        payload: instanceGusaBackend({
            method: 'get',
            url: ENDPOINTS.REVIEWS_GET({productId, limit, offset}),
        }),
    };
}

/**
 * Fetch reviews list
 * @param {number[]} productIds Product id
 * @param {number} offset Reviews offset
 * @returns {ActionType<AxiosPromise>} Action
 */
export function fetchReviewsWithPhotos({productIds, offset = 0, parentProductId}) {
    return {
        type: PRODUCT.FETCH_REVIEWS_PHOTOS_LIST,
        payload: instanceGusaBackend({
            baseURL: API_URL,
            method: 'get',
            params: {
                dir: 'random',
                hasPhoto: 1,
                limit: 100,
                offset,
                productIds,
                parentProductId,
            },
            url: ENDPOINTS.GET_REVIEWS_BY_PRODUCT_IDS,
        }),
    };
}

/**
 * Adds a review
 *
 * @param {ProductReviewFormType} review - Review data
 * @returns {ActionType<AxiosPromise>} - Action
 */
export const addReview = (review: ProductReviewFormType): ActionType<AxiosPromise> => ({
    type: PRODUCT.SEND_REVIEW,
    payload: instanceGusaBackend({
        method: 'POST',
        baseURL: API_URL,
        url: ENDPOINTS.REVIEWS_CREATE,
        data: review,
    }),
    meta: review,
});

/**
 * Save review files
 *
 * @param {string} fileSrc - Prescription file src
 * @returns {ActionType<AxiosPromise>} Action
 */
export function uploadReviewFile(fileSrc: string): ActionType<AxiosPromise> {
    return {
        type: PRODUCT.UPLOAD_REVIEW_FILE,
        payload: instanceGusaBackend({
            method: 'POST',
            baseURL: API_URL,
            url: ENDPOINTS.REVIEW_PHOTO,
            data: {photo: fileSrc},
        }),
    };
}
